export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '最新动态',
    slug: 'latest-news',
    description: '8x8x水蜜桃平台最新资讯、版本更新与活动公告，第一时间掌握平台动向。',
    icon: 'ri-flashlight-line',
    count: 15,
  },
  {
    id: 'cat-2',
    name: '使用指南',
    slug: 'user-guide',
    description: '从入门到精通，全面掌握8x8x水蜜桃的各项功能与使用技巧。',
    icon: 'ri-book-open-line',
    count: 22,
  },
  {
    id: 'cat-3',
    name: '资源推荐',
    slug: 'resources',
    description: '精选8x8x水蜜桃平台上最受欢迎的热门资源和精选内容合集。',
    icon: 'ri-star-line',
    count: 30,
  },
  {
    id: 'cat-4',
    name: '安全访问',
    slug: 'safe-access',
    description: '关于8x8x水蜜桃安全访问方式、官方入口验证及隐私保护指南。',
    icon: 'ri-shield-check-line',
    count: 12,
  },
  {
    id: 'cat-5',
    name: '常见问题',
    slug: 'faq',
    description: '解答用户关于8x8x水蜜桃的常见疑问，快速找到您需要的答案。',
    icon: 'ri-question-line',
    count: 18,
  },
];